import Vue from "vue";

/**
 *
 * Import Layout components
 *
 */

import SAuthSide from "./SAuthSide";
import SNavbar from "./SNavbar";
import SNavbarLink from "./SNavbarLink";
import SHeader from "./SHeader";
import SFooter from "./SFooter";

/**
 *
 * Import Reusable components
 *
 */
import SAlert from "./SAlert";
import SButton from "./SButton";
import SDataTable from "./SDataTable";
import SDatePicker from "./SDatePicker";
import STimePicker from "./STimePicker";
import SDialog from "./SDialog";
import SMenu from "./SMenu";
import SPasswordField from "./SPasswordField";
import STextField from "./STextField";
import STextArea from "./STextArea";
import SAutocomplete from "./SAutocomplete";

const components = [
  SAuthSide,
  SHeader,
  SFooter,
  SNavbar,
  SNavbarLink,
  SAlert,
  SButton,
  SDataTable,
  SDatePicker,
  STimePicker,
  SDialog,
  SMenu,
  SPasswordField,
  STextField,
  STextArea,
  SAutocomplete,
];

components.forEach((component) => {
  Vue.component(component.name, component);
});
